import PropTypes from "prop-types";
import TextAutocompleteField from "../text-autocomplete/TextAutocomplete";
import FormInputWrapper from "../form/FormInputWrapper";
import { useFormInput } from "./utils";

const TextAutocomplete = ({
    name,
    validations,
    label,
    description,
    helpText,
    className,
    position,
    ...rest
}) => {
    const { wrapperProps, inputProps } = useFormInput({
        name,
        validations,
        isControlled: true,
    });

    return (
        <FormInputWrapper
            {...{ label, description, helpText, className }}
            {...wrapperProps}
        >
            <TextAutocompleteField {...rest} {...inputProps} position={position} />
        </FormInputWrapper>
    );
};

TextAutocomplete.propTypes = {
    name: PropTypes.string.isRequired,
    validations: PropTypes.object,
    label: PropTypes.string,
    description: PropTypes.string,
    helpText: PropTypes.string,
    className: PropTypes.string,
    position: PropTypes.string,
};

export default TextAutocomplete;
